import { NgModule } from '@angular/core';
import { SmoothScroll } from './smooth-scroll';

@NgModule({
  declarations: [SmoothScroll],
  exports: [SmoothScroll]
})
export class SmoothScrollModule {
}
